import { useState } from "react";
import Donation from "./Donation";
import ThankYou from "./ThankYou";
import TKModal from "../Modal";

const MakeDonation = ({
  isOpen,
  onClose,
  currentStep,
  setCurrentStep,
  project,
  projectId,
  ngo,
}) => {
  const [offline, setOffline] = useState(0);

  const handleNextStep = () => {
    if (currentStep === 0) {
      return setCurrentStep((prev) => prev + 1);
    } else if (currentStep === 1) {
      return setCurrentStep((prev) => prev + 1);
    }
  };

  const steps = [
    <Donation
      setOffline={setOffline}
      next={handleNextStep}
      onClose={onClose}
      project={project}
      projectId={projectId}
      ngo={ngo}
    />,
    <ThankYou onClose={onClose} offline={offline} />,
  ];

  return (
    <TKModal open={isOpen} onClose={onClose}>
      {steps[currentStep]}
    </TKModal>
  );
};

export default MakeDonation;
